import { render } from "./ExpenseCard.vue?vue&type=template&id=6c60f8a7"
import script from "./ExpenseCard.vue?vue&type=script&lang=js"
export * from "./ExpenseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__